import React, { useRef } from "react";
import { Table as ReactstrapTable, Button, Form, FormGroup, Label, Input, FormText,Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { compose } from "recompose";
import { withTable } from "components/common";
import { withXeroErrors, withDocumentRenderer } from "components";
import { Trans, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CurrencySymbol, formatCurrency, formatDate } from "services/util";
import Search from "../Search";
import { InvoiceDocument } from "components/documents";
import { BulkDraftActions } from "../../components/BulkDraftActions";

const DocumentCell = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `invoice_${item.InvoiceNumber}.pdf`
    ),
  type: "SALES_INVOICE",
})(({ DownloadDocument, EmailDocument, DocumentRenderer, i }) => (
  <td className="text-end">
    <DownloadDocument compact item={i} className="mr-2" />
    <EmailDocument compact item={i} type="SALES_INVOICE" />
    <DocumentRenderer component={InvoiceDocument} />
  </td>
));

export const EInvoiceTable = ({
  XeroErrors,
  Pagination,
  TableContainer,
  ViewingRecords,
  Loader,
  XeroTableDataFetch,
  data,
  setFilters,
  DocumentRenderer,
  DownloadDocument,
  status,
  t,
  filters,
  selected,
  numSelected,
  refreshData,
}) => {
  const initialFilters = useRef(filters);

  return (
    <div className="inv-table">
      <XeroErrors color="warning" />
      <Search
        onFiltersChanged={(v) => {
          setFilters(v === null ? initialFilters.current : v);
        }}
        invoice
        status={status}
        isInvoice={true}
      />
      {status === "DRAFT" && (
        <BulkDraftActions
          onSuccess={refreshData}
          items={data.results}
          url="invoices"
          pk="InvoiceID"
          selected={selected}
        />
      )}
      <div className="small">
        <TableContainer idKey="InvoiceID">
          <ReactstrapTable size="sm" className="small" responsive>
            <thead>
              <tr>
                <th select />
                <th sortBy="InvoiceNumber" className="text-nowrap">
                  <Trans>Number</Trans>
                </th>
                <th sortBy="Reference" className="text-nowrap">
                  <Trans>Ref</Trans>
                </th>
                <th sortBy="Contact.Name" className="text-nowrap">
                  <Trans>To</Trans>
                </th>
                <th sortBy="Date" className="text-nowrap">
                  <Trans>Date</Trans>
                </th>
                <th sortBy="DueDate" className="text-nowrap">
                  <Trans>Due Date</Trans>
                </th>
                <th sortBy="ExpectedPaymentDate" className="text-nowrap">
                  <Trans>Expected Date</Trans>
                </th>
                <th className="text-right text-nowrap" sortBy="AmountPaid">
                  <Trans>Paid</Trans>
                </th>
                <th className="text-right text-nowrap" sortBy="AmountDue">
                  <Trans>Due</Trans>
                </th>
                <th sortBy="CurrencyCode" />
                <th sortBy="Status">
                  <Trans>Status</Trans>
                </th>
                <th sortBy="SentToContact">
                  <Trans>Sent</Trans>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {data.loading && (
                <tr>
                  <td colSpan="9" className="text-center">
                    <span className="fa fa-spinner fa-spin mt-2" /> <Trans>Loading...</Trans>
                  </td>
                </tr>
              )}
              {data.results.map((i, idx) => (
                <tr key={i.InvoiceID}>
                  <td select />
                  <td>
                    <Link
                      to={`/accounts_receivable/einvoices/view/${i.InvoiceID}`}
                    >
                      {i.InvoiceNumber}
                    </Link>
                  </td>
                  <td>{i.Reference}</td>
                  <td>
                    {i.Contact ? i.Contact.Name : null}
                  </td>
                  <td>{formatDate(i.Date)}</td>
                  <td>{formatDate(i.DueDate)}</td>
                  <td>{i.ExpectedPaymentDateString}</td>
                  <td className="text-right">{formatCurrency(i.AmountPaid)}</td>
                  <td className="text-right">{formatCurrency(i.AmountDue)}</td>
                  <td><CurrencySymbol currency={i.CurrencyCode} /></td>
                  <td>{i.Status}</td>
                  <td className="text-success">
                    {i.SentToContact ? t("Sent") : ""}
                  </td>
                  <DocumentCell i={i} />
                </tr>
              ))}
            </tbody>
          </ReactstrapTable>
        </TableContainer>
      </div>
      <XeroTableDataFetch />
      <div className="float-right">
        <Pagination size="sm" count={'Pages'}/>
      </div>
      <div className="clearfix">
        <ViewingRecords noCount className="float-left" />
      </div>

    </div>
  );
};

export const enhance = compose(
  withTranslation(),
  withXeroErrors(),
  withTable({
    limit: 50, 
    url: "invoices",
    ordering: {
      column: "Date",
      direction: 2,
    },
  }),
  withDocumentRenderer({
    onDownload:
      ({ xero }) =>
      (getDocument, item) => {
        getDocument({ item }, `invoice_${item.InvoiceNumber}.pdf`);
      },
  })
);

export default enhance(EInvoiceTable);
